<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <nav class="bottom-nav">
    <router-link
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      class="nav-item">
      <component :is="item.icon" />
      <span>{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script setup>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { Home, PawPrint, ListChecks, MapPinHouse, MoreHorizontal } from 'lucide-vue-next'
  
import Hoof from '/src/assets/images/hoof.svg?component'

  const { t } = useI18n()

  const items = computed(() => [
    { name: 'Home', label: t('bottomMenu.home'), to: '/', icon: Home }, // Temporarily disabled - under development
    { name: 'Goats', label: t('bottomMenu.goats'), to: '/goats', icon: Hoof },
    { name: 'SessionSelect', label: t('bottomMenu.session'), to: '/session-select', icon: ListChecks },
    { name: 'Groups', label: t('bottomMenu.groups'), to: '/groups', icon: MapPinHouse },
    { name: 'More', label: t('bottomMenu.more'), to: '/more', icon: MoreHorizontal },
  ])
</script>
